import { useEffect } from 'react';
import { connect, useDispatch } from "react-redux";
import { getNotification } from '../../actions/notification';
import NotificationTabs from "./NotificationTabs";
import { useLocation } from 'react-router';
import { getItem } from '../../utils/DataProtection';

export default connect(({ }) => ({}), { getNotification })(props => {
  const location = useLocation();
  const nodeid = new URLSearchParams(location.search).get('nodeid');
  const dispatch = useDispatch();

  useEffect(() => {
    const nodeidLS = getItem('notification-nodeid')
    const targetNodeId = nodeid !== null ? nodeid : nodeidLS;

    if (targetNodeId) {
      props.getNotification({ nodeid: targetNodeId }, 'GETSINGLENOTIFICATION')
    }
  }, [nodeid, props.getNotification])

  useEffect(() => {
    return () => {
      if(!window.location.href.includes("nodeid") && !window.location.pathname.includes("create-report") && !window.location.pathname.includes("edit-report") && !window.location.pathname.includes("notification-details") && !window.location.pathname.includes("edit-notification")){
      dispatch({ type: 'CLEARNOTIFICATION', payload: {} });
      }
    }
  }, [])

  return (
    <>
      <NotificationTabs />
    </>
  );
})
